<template>
    <div>

        <vue-headful title="Equipment Types :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                <li class="breadcrumb-item active">Equipment Types</li>
                <li class="ml-3">
                    <router-link :to="`/admin/equipment-types-edit`" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> New</router-link>
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="equipmentTypeTable" url="/admin/equipment-types-list" :columns="columns" :options="options">

                    <router-link slot="equipment_type_id" slot-scope="props" :to="`/admin/equipment-types-edit/${props.row.equipment_type_id}`" title="Edit Equipment Type" class="btn btn-sm btn-info">
                        <i class="fa fa-edit"></i> Edit
                    </router-link>

                    <router-link slot="equipment_type_name" slot-scope="props" :to="`/equipment/types/${props.row.equipment_type_id}`" title="View Equipment Type">
                        {{ props.row.equipment_type_name }}
                    </router-link>

                    <template slot="require_inspection" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.require_inspection == 1">Yes</label>
                        <label class="badge badge-warning" v-else>No</label>
                    </template>

                    <template slot="require_tracking_jobsite" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.require_tracking_jobsite == 1">Yes</label>
                        <label class="badge badge-warning" v-else>No</label>
                    </template>

                    <template slot="use_absolute_usage" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.use_absolute_usage == 1">Yes</label>
                        <label class="badge badge-warning" v-else>No</label>
                    </template>

                    <template slot="is_active" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                        <label class="badge badge-warning" v-else>Inactive</label>
                    </template>

                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['equipment_type_id', 'equipment_type_name', 'equipment_usage_type_name', 'require_inspection', 'require_tracking_jobsite', 'use_absolute_usage', 'is_active'],
                options: {
                    headings: {
                        equipment_type_id: 'Edit',
                        equipment_type_name: 'Type Name',
                        equipment_usage_type_name: 'Default Usage Type',
                        require_inspection: 'Require Inspection',
                        require_tracking_jobsite: 'Require Jobsite',
                        use_absolute_usage: 'Use Current Value',
                        is_active: 'Active',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'equipment_types.equipment_type_name',
                    },
                    uniqueKey: 'equipment_type_id',
                },
            }
        },

        methods: {

        },
    }
</script>
